import { NoteLabel } from '@seen/core/models/noteLabel'
import { isVisitNoteCategoryToken } from '@seen/core/models/visitNoteCategory'

interface PartitionLabelSelectionResult {
  labels: NoteLabel['referenceString'][]
  categories: string[]
}

// The note-label picker speaks one flat array mixing `Basic/<id>` label
// references and `system|code` category tokens; split it back by predicate
// before writing, the same contract the template detail-page picker uses.
// Unknown values (e.g. deleted labels) are dropped from both sides.
export function partitionLabelSelection(
  value: string[]
): PartitionLabelSelectionResult {
  return {
    labels: value.filter(NoteLabel.isValidReferenceString),
    categories: value.filter(isVisitNoteCategoryToken),
  }
}
